module.exports = __webpack_public_path__ + "img/warning-confirm.3b276eec.svg";